var _circle, _circle2, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStateEmployee(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130,
    fill: "#E8F0FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15305_2169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 260,
    height: 260
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15305_2169)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8709 163.742C94.3093 163.742 115.742 142.309 115.742 115.871C115.742 89.4325 94.3093 68 67.8709 68C41.4325 68 20 89.4325 20 115.871C20 142.309 41.4325 163.742 67.8709 163.742Z",
    fill: "#C7D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 117.5C118 144.286 96.2858 166 69.5 166C42.7142 166 21 144.286 21 117.5C21 90.7142 42.7142 69 69.5 69C96.2858 69 118 90.7142 118 117.5Z",
    fill: "#C7D9FF",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15305_2169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 70,
    width: 95,
    height: 95
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 165C95.7335 165 117 143.734 117 117.5C117 91.2665 95.7335 70 69.5 70C43.2665 70 22 91.2665 22 117.5C22 143.734 43.2665 165 69.5 165Z",
    fill: "#CCCDFA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15305_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5234 136.784C61.0172 136.784 54.9322 135.927 54.9322 134.871C54.9322 133.815 61.0172 132.959 68.5234 132.959C76.0295 132.959 82.1145 133.815 82.1145 134.871C82.1145 135.927 76.0295 136.784 68.5234 136.784Z",
    fill: "#6C108C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3447 118.496H80.4351V145.528H56.3447V118.496Z",
    fill: "#E2988F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0611 100.976C45.4316 97.7189 48.2298 99.3233 48.2298 99.3233C46.6145 84.5273 54.1851 74.7632 68.3881 74.7632C82.5911 74.7632 90.1616 84.5273 88.5464 99.3233C88.5464 99.3233 91.3445 97.727 92.7151 100.976C94.0856 104.226 91.5811 111.859 90.0311 114.29C88.4811 116.712 85.74 118.552 85.74 118.552C85.74 118.552 85.5605 121.274 84.8426 123.17C84.1247 125.066 76.0239 133.769 73.6418 135.098C70.5173 136.921 65.9162 136.921 63.1099 135.098C60.7278 133.769 52.6269 125.058 51.909 123.17C51.1911 121.274 51.0117 118.552 51.0117 118.552C51.0117 118.552 48.2706 116.72 46.7206 114.29C45.1706 111.867 42.6742 104.234 44.0366 100.976H44.0611Z",
    fill: "#E2988F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3874 74.7632C82.5904 74.7632 90.161 84.5273 88.5457 99.3233C86.6694 100.539 86.237 103.837 86.5307 107.102C86.5307 107.102 87.1589 117.498 85.0949 122.409C83.0391 127.311 79.4496 134.976 68.3874 134.887C57.3253 134.985 53.7357 127.319 51.6799 122.409C49.6241 117.506 50.2442 107.102 50.2442 107.102C50.5379 103.983 50.546 100.555 48.2292 99.3233C46.6139 84.5273 54.1844 74.7632 68.3874 74.7632ZM52.8466 97.492C52.8466 97.492 53.1239 111.065 55.2287 114.038C57.3416 117.012 56.6808 110.416 68.3793 110.303C80.0778 110.189 79.4251 117.012 81.538 114.038C83.6428 111.073 83.9202 97.5488 83.9202 97.492C83.7815 94.4939 83.4878 91.6255 82.1907 90.3452C80.5101 88.6841 78.0546 88.9515 75.958 89.4863C73.5106 90.1102 70.9817 90.9448 68.3956 91.0097C65.6627 91.0826 63.0603 90.0859 60.4416 89.4539C58.4021 88.9677 56.1913 88.7489 54.576 90.3452C53.2789 91.6336 52.9852 94.4939 52.8466 97.5001V97.492Z",
    fill: "#2F2974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1812 143.703C38.5942 140.956 54.9427 140.219 54.9427 140.219C63.378 146.879 74.6605 146.969 82.125 140.219C82.125 140.219 98.1716 141.256 109.495 143.93C102.169 159.155 86.514 169.673 68.3952 169.673C50.1785 169.673 34.4744 159.05 27.1894 143.703H27.1812Z",
    fill: "url(#paint0_linear_15305_2169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1145 134.872V141.638C72.4718 148.703 63.4002 148.801 54.9322 141.638V134.872C59.7291 137.959 79.039 137.537 82.1145 134.872Z",
    fill: "url(#paint1_linear_15305_2169)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.025 163.742C218.463 163.742 239.896 142.309 239.896 115.871C239.896 89.4325 218.463 68 192.025 68C165.586 68 144.154 89.4325 144.154 115.871C144.154 142.309 165.586 163.742 192.025 163.742Z",
    fill: "#C7D9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242 117.5C242 144.286 220.286 166 193.5 166C166.714 166 145 144.286 145 117.5C145 90.7142 166.714 69 193.5 69C220.286 69 242 90.7142 242 117.5Z",
    fill: "#C7D9FF",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15305_2169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 69,
    width: 96,
    height: 96
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.935 164.871C220.409 164.871 241.871 143.409 241.871 116.935C241.871 90.4614 220.409 69 193.935 69C167.461 69 146 90.4614 146 116.935C146 143.409 167.461 164.871 193.935 164.871Z",
    fill: "#6467EF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15305_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.817 145.114C151.405 136.752 158.808 123.031 170.055 104.656C171.677 102.004 172.716 99.0551 173.347 96.0122C175.182 87.1101 183.112 80.4062 192.618 80.4062C202.124 80.4062 210.188 87.2118 211.937 96.2312C212.543 99.368 213.543 102.419 215.048 105.243C225.388 124.674 235.508 140.334 220.734 145.122H163.809L163.817 145.114Z",
    fill: "#2F2974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3 116.311H202.895V142.406H182.3V116.311Z",
    fill: "#DF8569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.34 144.378C161.807 140.334 180.897 137.283 180.897 137.283C188.226 142.962 197.495 142.923 203.26 137.283C203.26 137.283 222.595 139.919 233.505 143.432C225.708 156.175 211.167 164.959 194.323 165.663C193.566 165.687 192.818 165.71 192.053 165.71C174.732 165.687 159.597 157.129 151.332 144.37L151.34 144.378Z",
    fill: "url(#paint2_linear_15305_2169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.892 134.319L206.948 137.933C206.948 137.933 204.577 148.071 199.742 148.259C194.906 148.446 192.614 141.516 192.614 141.516C197.237 140.287 200.655 137.886 202.884 134.311L202.892 134.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.311 134.318L178.255 137.932C178.255 137.932 180.626 148.07 185.461 148.258C190.297 148.445 192.589 141.515 192.589 141.515C187.966 140.286 184.548 137.885 182.319 134.31L182.311 134.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.27 83.0734C182.434 77.9561 185.932 73.1343 191.084 72.3036C196.236 71.473 201.091 74.948 201.927 80.0653C202.763 85.1826 199.265 90.0044 194.113 90.8351C188.961 91.6658 184.106 88.1907 183.27 83.0734Z",
    fill: "#2F2974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.625 84.7075C205.903 84.7232 208.92 94.5952 208.644 104.538C208.644 111.703 209.156 114.026 208.486 115.802C208.116 118.329 202.95 131.212 192.633 131.212C182.316 131.212 177.591 119.009 176.677 115.802C176.008 114.026 176.614 111.703 176.614 104.538C176.338 94.5952 179.355 84.7232 192.633 84.7075H192.625Z",
    fill: "#DF8569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.064 104.772C208.064 104.772 210.734 101.354 213.475 103.356C216.215 105.359 213.546 116.709 208.064 114.714C202.583 112.712 208.064 104.78 208.064 104.78V104.772Z",
    fill: "#DF8569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14 104.772C177.14 104.772 174.471 101.354 171.73 103.356C168.989 105.359 171.659 116.709 177.14 114.714C182.622 112.712 177.14 104.78 177.14 104.78V104.772Z",
    fill: "#DF8569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3 99.7741C198.771 101.988 187.674 102.152 175.9 99.7741C175.9 99.7741 175.679 83.6285 192.155 83.0887C208.631 82.5568 209.3 99.7741 209.3 99.7741Z",
    fill: "#2F2974"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.635 220.195C156.109 220.195 177.57 198.734 177.57 172.26C177.57 145.786 156.109 124.324 129.635 124.324C103.161 124.324 81.6995 145.786 81.6995 172.26C81.6995 198.734 103.161 220.195 129.635 220.195Z",
    fill: "#C7D9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178 172.5C178 199.286 156.286 221 129.5 221C102.714 221 81 199.286 81 172.5C81 145.714 102.714 124 129.5 124C156.286 124 178 145.714 178 172.5Z",
    fill: "#C7D9FF",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15305_2169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 125,
    width: 95,
    height: 95
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 220C155.734 220 177 198.734 177 172.5C177 146.266 155.734 125 129.5 125C103.266 125 82 146.266 82 172.5C82 198.734 103.266 220 129.5 220Z",
    fill: "#FFCC00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15305_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.316 175.987C101.121 157.526 108.78 134.052 129.825 132.719C136.538 132.293 143.097 134.743 146.486 139.475C158.1 144.022 159.079 164.282 157.777 171.255C154.218 190.375 171.372 187.081 167.021 205.028L131.168 203.067H129.793L94.5779 203.517C91.6097 189.981 105.772 190.889 104.324 175.995L104.316 175.987Z",
    fill: "#2F2974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 173.682H141.198V200.482H120.048V173.682Z",
    fill: "#B1644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8047 202.505C101.761 198.351 119.918 195.218 119.918 195.218C126.89 201.051 135.706 201.01 141.189 195.218C141.189 195.218 159.581 197.926 169.958 201.533C162.541 214.619 148.711 223.64 132.689 224.363C131.969 224.388 131.257 224.412 130.53 224.412C114.055 224.388 99.6581 215.599 91.7966 202.497L91.8047 202.505Z",
    fill: "url(#paint3_linear_15305_2169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.651 141.227C144.287 141.243 147.385 151.381 147.102 161.592C147.102 168.95 147.15 174.381 146.463 176.196C145.775 178.012 140.995 188.962 130.659 188.986C120.323 188.97 115.543 178.02 114.855 176.196C114.168 174.373 114.208 168.95 114.208 161.592C113.925 151.381 117.023 141.243 130.659 141.227H130.651Z",
    fill: "#B1644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.492 161.244C146.492 161.244 149.234 157.235 152.048 159.581C154.863 161.927 152.121 175.23 146.492 172.884C140.863 170.539 146.492 161.244 146.492 161.244Z",
    fill: "#B1644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.751 161.244C114.751 161.244 112.009 157.235 109.194 159.581C106.38 161.927 109.121 175.23 114.751 172.884C120.38 170.539 114.751 161.244 114.751 161.244Z",
    fill: "#B1644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.185 160.425C147.314 153.251 141.919 149.523 141.919 149.523C137.067 157.975 123.689 160.842 111.469 156.649C111.469 156.649 112.658 136.349 131.745 137.538C150.832 138.727 147.177 160.417 147.177 160.417L147.185 160.425Z",
    fill: "#2F2974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.449 195.153C132.263 201.702 125.713 198.428 120.801 195.153L110.977 196.79C128.006 213.818 145.361 203.885 150.273 196.79L140.449 195.153Z",
    fill: "url(#paint4_linear_15305_2169)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15305_2169",
    x1: 68.3381,
    y1: 167.29,
    x2: 68.3381,
    y2: 122.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A416D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0B7EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15305_2169",
    x1: 74.9559,
    y1: 147.053,
    x2: 59.4946,
    y2: 134.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF92E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849385,
    stopColor: "#E6B1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15305_2169",
    x1: 192.418,
    y1: 165.71,
    x2: 192.418,
    y2: 137.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E0A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15305_2169",
    x1: 108.681,
    y1: 194.777,
    x2: 125.919,
    y2: 268.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AC880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EAB73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15305_2169",
    x1: 121.423,
    y1: 194.027,
    x2: 128.168,
    y2: 212.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9F4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DDFB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateEmployee);
export default __webpack_public_path__ + "static/media/empty-state-employee.58929d91.svg";
export { ForwardRef as ReactComponent };